// @ts-ignore
// @ts-nocheck
import React from 'react';
import Navbar from 'components/layout/NavbarNew';
import UserMenu from 'components/layout/UserMenu';
import { BoxPadding, Scrollbar } from './styles';
import { GenericNavBarProps } from './types';

const GenericNavBar: React.FC<GenericNavBarProps> = ({
  children,
  selected,
  breadcrump,
  withTable,
  intro,
  openSubMenu,
}) => {
  return (
    <Navbar selected={selected} withTable={withTable} openSubMenu={openSubMenu}>
      <UserMenu intro={intro} />
      <BoxPadding>
        <Scrollbar>{children}</Scrollbar>
      </BoxPadding>
    </Navbar>
  );
};

export default GenericNavBar;
